export default {
  data () {
    return {
      fields: [
        {
          prop: 'id',
          label: 'ID',
          width: 80,
        },
        {
          prop: 'company_name',
          label: '公司名称',
          minWidth: 120,
        },
        {
          prop: 'bank_info',
          label: '开户银行及帐号',
          minWidth: 120,
        },
        {
          prop: 'address_phone',
          label: '地址及电话',
          minWidth: 120,
        },
        {
          prop: 'tax_number',
          label: '税号',
          minWidth: 120,
        },
        {
          prop: 'is_disabled',
          label: '禁用状态',
          minWidth: 120,
          formatter: row => row.is_disabled ? '已禁用' : '启用中'
        },
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/customer-receipt/customer-receipt.mixins.js